function addLoader() {
  const simpleLinkClass = '.navtab__link-container';
  const eventDataId = '#event__active--data';
  const eventLoaderId = '#event-loader';

  const tabs = [...document.querySelectorAll(simpleLinkClass)];

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      document.querySelector(eventLoaderId).style.display = 'flex';
      document.querySelector(eventDataId).style.display = 'none';
    });
  });
}

export default {
  initialize: addLoader,
};
